import React, { ChangeEvent, useCallback, useMemo, useState } from 'react';
import UITextInput from 'Components/UIComponents/UITextInput';
import { debounce } from 'lodash-es';

interface DebounceInputProps {
  placeholder: string;
  onChange: (value: string) => void;
  icon?: string;
}

const DebounceInput = ({ placeholder, onChange, icon }: DebounceInputProps) => {
  const [value, setValue] = useState('');

  const debouncedOnChange = useMemo(() => debounce(onChange, 1000), [onChange]);

  const handleChangeValue = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setValue(event.target.value);
      debouncedOnChange(event.target.value.trim());
    },
    [debouncedOnChange],
  );

  return (
    <UITextInput
      placeholder={placeholder}
      value={value}
      onChange={handleChangeValue}
      icon={icon}
    />
  );
};

export default DebounceInput;
